<template>
  <icon-question-filled ref="icon"
                        width="12"
                        height="12"
                        color="#999ca7" />
</template>

<script>
import tippy from 'tippy.js'

export default {
  mounted () {
    tippy(this.$refs.icon.$el, {
      content: 'The percentage is calculated as the average uptime of all locations we ping from for the latest 90 days.'
    })
  }
}
</script>
